<template>
    <div v-on-click-outside="onClickOutside" class="vz-dropdown-checkbox">
        <div class="vz-dropdown-checkbox-title" @click="onShowList">
            <span>{{ title }}</span>
        </div>
        <div v-show="isShowList" class="vz-dropdown-checkbox-list">
            <div class="vz-dropdown-checkbox-list-item vz-dropdown-checkbox-list-item-all">
                <vz-checkbox v-model="allItems" label="Для всех" />
            </div>
            <div v-for="(item, index) of items" :key="index" class="vz-dropdown-checkbox-list-item">
                <vz-checkbox v-model="item.value" :label="item.title" :disabled="disabled"
                    @change="onChange(item, index)" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { VzDropdownItem } from "~/types/types"
import { PropType } from "vue"

const emit = defineEmits(['change-all', 'change'])
const props = defineProps({
    items: {
        type: Array as PropType<VzDropdownItem[]>,
        default: () => []
    },
    disabled: {
        type: Boolean,
        default: false
    }
})
let isShowList = ref(false)

const title = computed((): string => {
    return props.items
      .filter(item => item.value)
      .map(item => item.title)
      .join('; ')
})

const allItems = computed({
    get(): boolean {
        let allItems = true
        props.items.forEach((item) => {
            if (!item.value) {
                allItems = false
            }
        })
        return allItems
    },
    set(value: boolean) {
        emit('change-all', { status: value })
    }
})


const onChange = (item: VzDropdownItem, index: number): void => {
    emit('change', { status: item.value, index })
}

const onClickOutside = (): void => {
    if (isShowList.value) {
        isShowList.value = false
    }
}

const onShowList = (): void => {
    isShowList.value = !isShowList.value
}
</script>